import { BehaviorSubject } from 'rxjs';
export const getDisplayUserStore = () => {
    const getInitialState = () => ({
        email: '',
        firstName: '',
        lastName: '',
        userAssociations: [{
                clientName: '',
                availableUsersNo: null,
                companyName: '',
                companyRoles: [],
                roleId: null
            }]
    });
    const displayUserSubject = new BehaviorSubject(getInitialState());
    const subscribe = (callback) => displayUserSubject.subscribe(callback);
    const setDisplayUserModel = (displayUserModel) => {
        displayUserSubject.next(displayUserModel);
    };
    const reset = () => {
        displayUserSubject.next(getInitialState());
    };
    return {
        getInitialState,
        subscribe,
        setDisplayUserModel,
        reset
    };
};
